<template>

  <div>
    <li class="nav-item nav-link  " v-if="item.children.length !== 0">
      <m-menu-icon-manager  class="m-0  " dir="ltr"
                           :item-icon="item.icon_class"/>


      <template v-if="item.children.length !== 0">
        <m-a class="nav-link dropdown-toggle rounded m-0 p-0 text-dark d-inline-block" href="#" id="navbarDropdown"
             role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <span class="nav-2-nav-menu-item">{{ item.name }}</span>
        </m-a>
        <div class="dropdown-menu " aria-labelledby="navbarDropdown">
          <m-a v-for="child in item.children" :key="child.id" class="dropdown-item" :href="child.url">
            <span class="nav-2-nav-menu-sub-item">{{ child.name }}</span>
            <m-menu-icon-manager :item-icon="child.icon_class"/>
          </m-a>
        </div>
      </template>
    </li>

    <li class="nav-item nav-link  " v-else>
      <m-a :href="item.url" class="text-dark">
        <m-menu-icon-manager class="m-0 " dir="ltr" :item-icon="item.icon_class"/>
        <span class="nav-2-nav-menu-item">{{ item.name }}</span>
      </m-a>
    </li>

  </div>

</template>

<script>
import mIcon from "../../Icons/Icon";
import mA from '../../Tags/A'
import mMenuIconManager from "../../Menu/MenuIconManager.vue";

export default {
  name: "NavMenuItem",
  components: {mMenuIconManager, mIcon, mA},
  props: {
    item: {}
  }
}
</script>

<style scoped>

.dropdown-menu {
  left: unset;
  text-align: right;
  direction: ltr;
}

.nav-2-nav-menu-item {
  margin-right: 3px;
  font-size: 12px;
}


</style>